import { render, staticRenderFns } from "./Locality.vue?vue&type=template&id=1fde6429&scoped=true&"
import script from "./Locality.vue?vue&type=script&lang=js&"
export * from "./Locality.vue?vue&type=script&lang=js&"
import style0 from "./Locality.vue?vue&type=style&index=0&id=1fde6429&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fde6429",
  null
  
)

export default component.exports